module.exports = __webpack_public_path__ + "static/startupedia-6144caa1fa03b25a7177c9d62c08379e.png";